interface FooterProps {
  onLinkClick: () => void;
}

export default function Footer({ onLinkClick }: FooterProps) {
  return (
    <footer className="relative bg-zinc-950 border-t border-zinc-800 px-6 py-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              THOMAS
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Premium psychological entertainment and keynote speaking for corporate events and MICE planners worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/')}
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={onLinkClick}
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm cursor-pointer"
                >
                  About Thomas
                </button>
              </li>
              <li>
                <button 
                  onClick={onLinkClick}
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm cursor-pointer"
                >
                  Performance Types
                </button>
              </li>
              <li>
                <button 
                  onClick={onLinkClick}
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Connect</h4>
            <div className="flex gap-3">
              <button 
                onClick={onLinkClick}
                className="w-10 h-10 flex items-center justify-center bg-zinc-900 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg text-white"></i>
              </button>
              <button 
                onClick={onLinkClick}
                className="w-10 h-10 flex items-center justify-center bg-zinc-900 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg text-white"></i>
              </button>
              <button 
                onClick={onLinkClick}
                className="w-10 h-10 flex items-center justify-center bg-zinc-900 rounded-full hover:bg-red-600 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg text-white"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2025 Thomas. All rights reserved.
          </p>
          <div className="flex gap-6">
            <button 
              onClick={onLinkClick}
              className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer"
            >
              Privacy Policy
            </button>
            <button 
              onClick={onLinkClick}
              className="text-gray-500 hover:text-red-500 transition-colors text-sm cursor-pointer"
            >
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}